import { useEffect, useRef, useState } from "react";
import "@arcgis/core/assets/esri/themes/light/main.css"
import { MapService } from "../../service/mapService";
import SgvMapComponent from "./SgvMapComponent";
import { user_state } from "../../features/user/userSlice";
import { useSelector } from "react-redux";


const SgvMapByIdComponent = ({ mapId}) => {

    const [mapConfig, setMapConfig] = useState(null)
    const userstate = useSelector(user_state);

    const getMapContent = () => {
        //TODO recuperar si hay usuario loggeado, y el contenido asociado al mismo
        MapService.getMap(mapId)
            .then((data) => {
                //console.log("SgvMapByIdComponent getMapContent", data);                 
                setMapConfig(data)
                console.log("mapConfig", data)
            })
            .catch(err => {
                console.log('error',err)
                err.response.json().then(res => {
                    //console.log('error',res);
                });
            })
    }

    useEffect(() => {
        getMapContent();        
    }, [])

    useEffect(() => {
       //Si cambia el estadod e login, recargamos todo 
       getMapContent();
    }, [userstate])

   
    return (
        <>
           {mapConfig && <SgvMapComponent mapConfig={mapConfig}></SgvMapComponent>}
        </>
    )
}
export default SgvMapByIdComponent;